import React, { useState,useEffect } from 'react';
import { Popup } from "@progress/kendo-react-popup";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import _ from 'lodash';

const ContextMenu = (props) => {  
  const {removeAction} = props;

  const [data, setData] = useState();
  const [dataRelatedAction, setDataRelatedAction] = useState([]);
  const [planRelatedAction, setPlanRelatedAction] = useState([]);
  const [agendaAction, setAgendaAction] = useState([]);
  const [customActionsData, setCustomActionsData] = useState([]);
  const [cardItem,setCardItem] = useState([])

  let storedDroppedItems = props.data ? _.cloneDeep(props.data) : [];
  const customActions = props?.customActions || [];
  let customActionsItems = customActions?.map(action => action.caption);
  const isDataGrid = ['dataGrid','scheduler'].includes(props?.flag);
  let menuAction = []

  if(props?.flag === 'dataGrid')
    menuAction.push('Copy Cell Value')
  if(!props?.nonFilterableColumnData?.includes(props?.contextData?.field) && props?.flag === 'dataGrid')
    menuAction.push('Filter On This Value')

  const handleMenuItemClick = (item) => {
    // Call the parent function when a menu item is clicked
    // let word = item.item.text.replaceAll('Plan On ','').toLowerCase();
    const word = item.item.text.toLowerCase();
    if (isDataGrid) {
      if (customActionsItems?.includes(item.item.text)) {
        const filterCustomAction = customActions?.filter(x => x.caption === item.item.text);
        props.sendToParent(filterCustomAction[0].id, props.Id, props.contextData, true);
      } else {
        props.sendToParent(word.replace(' ','-'), props?.routeIdAction?.includes(item.item.text) ? props?.routeId : props?.Id, props.contextData);
      }
    } else {
      props.sendToParent(word.replace(' ','-'));
    }
  };
  useEffect(() => {
    if(props.data != data){
    if (isDataGrid) {
      setPlanRelatedAction(getTitleData('planRelatedAction'));
      setAgendaAction(getTitleData('agendaAction'))
      setDataRelatedAction(getTitleData('dataRelatedAction'));
    } else {
      setData(storedDroppedItems);
    }
    setCardItem(props?.card)
    setCustomActionsData(customActionsItems);
  }
  }, [props]);
  
  const getTitleData = (sourceItem) => {
    return storedDroppedItems?.filter(x => x.source === sourceItem)?.map(item => item.title);
  }

  return (
    <Popup show={true} offset={props.offset} className={"context-menu"}>
      <Menu 
        onSelect={(event) => handleMenuItemClick(event)}
        vertical={true}
        style={{
          display: "block"
        }}
        >
          {isDataGrid && menuAction.map((elem,index)=>(
            <MenuItem key={index} text={elem} />
          ))}
          {agendaAction?.map((item, index) => (
            <MenuItem key={index} text={item} />
          ))}
          {isDataGrid ? (
              storedDroppedItems?.length > 0 && agendaAction.length == 0 && <MenuItem key={1} text={'Actions'}> 
                {planRelatedAction?.map((item, index) => (
                  !removeAction?.includes(item) && <MenuItem key={index} text={item} />  
                ))}
                {removeAction?.length > 0 && 
                  <MenuItem text={'Remove'} className={"context-menu text-wrap"} cssStyle={{  }}>
                    {removeAction?.map((elem,index)=>(
                      planRelatedAction.includes(elem) && <MenuItem key={index} text={elem} />
                    ))} 
                  </MenuItem>
                }

                {/* Separator */}
                {(planRelatedAction?.length > 0 && dataRelatedAction?.length > 0) && 
                  <MenuItem disabled cssStyle={{ padding: 0, borderTop: '1px dashed black', height: 0 }} />}

                {dataRelatedAction?.map((item, index) => (
                  <MenuItem key={index} text={item} />
                ))}
              </MenuItem>
          ): data?.map((item, index) => (
            <MenuItem key={index} text={item} />
          ))}
          {isDataGrid && (
              customActionsData?.length > 0 && <MenuItem key={1} text={'Custom Actions'}> 
                {customActionsData?.map((item, index) => (
                <MenuItem key={index} text={item} />
              ))}
              </MenuItem>
          )}
          {
            isDataGrid && (
              cardItem?.length > 0 && <MenuItem key={1} text={'Card'}> 
                {cardItem?.map((item, index) => (
                <MenuItem key={index} text={item.title} />
              ))}
            </MenuItem>
          )}
      </Menu>
    </Popup>
  )
}

export default ContextMenu;